import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import MdAccessTime from 'react-icons/lib/md/access-time'
import moment from 'moment'
import withOrganization from 'App/Decorators/withOrganization'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'

@withOrganization
@withRouter
export default class Pending extends React.Component {
  static propTypes = {
    userId: PropTypes.string,
    router: PropTypes.object
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/admin/${this.props.userId}/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {title: '', name: '_id', render: () => <MdAccessTime size={20} />},
        {title: 'Nombre', name: 'name'}
      ]
    }
    return [
      {title: '', name: '_id', render: () => <MdAccessTime size={20} />},
      {title: 'Nombre', name: 'name'},
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      }
    ]
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Documentos sin firmar</h3>
          </div>
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              queryName="userPending"
              defaultLimit={25}
              fields={this.getFields()}
              params="$filter: String $userId: String"
              userId={this.props.userId}
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/UserInformation/Pending/index.js